import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {adminRequest, buildQuery, getReturnedObject} from "../../api/adminApi";

const initialState = {
  tickets: null as any[] | null,
  selectedTicket: null as any,
  loading: false,
  error: undefined as string | undefined,
  pageInfo: {pageNumber: 1, pageSize: 10, totalItems: 0, totalPages: 0},
};

export const getSupportTickets = createAsyncThunk<any, {token: string; searchParam?: string; pageNumber?: number; status?: number; issueType?: number}>(
  "supportTickets/getAll",
  async (data: {token: string; searchParam?: string; pageNumber?: number; status?: number; issueType?: number}) =>
    adminRequest(`/support-tickets${buildQuery({
      searchParam: data.searchParam,
      pageNumber: data.pageNumber || 1,
      pageSize: 10,
      status: data.status,
      issueType: data.issueType,
    })}`, {token: data.token})
);

export const getSupportTicketById = createAsyncThunk<any, {token: string; ticketId: string}>(
  "supportTickets/getById",
  async (data: {token: string; ticketId: string}) =>
    adminRequest(`/support-tickets/${data.ticketId}`, {token: data.token})
);

export const updateSupportTicketStatus = createAsyncThunk<any, {token: string; ticketId: string; status: number; adminNote?: string}>(
  "supportTickets/updateStatus",
  async (data: {token: string; ticketId: string; status: number; adminNote?: string}) =>
    adminRequest(`/support-tickets/${data.ticketId}/status`, {
      method: "PATCH",
      token: data.token,
      body: JSON.stringify({status: data.status, adminNote: data.adminNote}),
    })
);

const supportTicketSlice = createSlice({
  name: "supportTickets",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupportTickets.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(getSupportTickets.fulfilled, (state, action) => {
        const result = getReturnedObject(action.payload);
        const tickets = result?.tickets || [];
        state.loading = false;
        state.tickets = tickets.map((item: any) => ({...item, key: item.id}));
        state.pageInfo = {
          pageNumber: result?.pageNumber || 1,
          pageSize: result?.pageSize || 10,
          totalItems: result?.totalRecords || 0,
          totalPages: Math.ceil((result?.totalRecords || 0) / (result?.pageSize || 10)),
        };
      })
      .addCase(getSupportTicketById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
        state.selectedTicket = null;
      })
      .addCase(getSupportTicketById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTicket = getReturnedObject(action.payload);
      })
      .addCase(updateSupportTicketStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTicket = getReturnedObject(action.payload);
      })
      .addMatcher(
        (action) => action.type.startsWith("supportTickets/") && action.type.endsWith("/rejected"),
        (state, action: any) => {
          state.loading = false;
          state.error = action.error?.message;
        }
      );
  },
});

export default supportTicketSlice.reducer;
